import { createBrowserRouter, Outlet } from 'react-router';
import { routes } from '@/router/routes.tsx';
import { LoginPage } from '@/pages/login-page.tsx';
import { ErrorPage } from '@/pages/error-page.tsx';
import { PrivateRoutes } from '@/router/PrivateRoutes.tsx';
import { AppLayout } from '@/components/layouts/AppLayout.tsx';
import { LogoutPage } from '@/pages/logout-page.tsx';
import { PageLayout } from '@/components/layouts/PageLayout.tsx';
import { HomePage } from '@/pages/home-page.tsx';
import { auditLogRoutes } from '@/pages/audit-logs';
import { dataMaskingRoutes } from '@/pages/data-masking';
import { Permission } from '@/features/auth/auth.def.ts';
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx';
import { fundManagementRoutes } from '@/pages/fund-management';
import { investorManagementRoutes } from '@/pages/investor-management';
import { customerRelationshipManagementRoutes } from '@/pages/customer-relationship-management';
import { referenceDataRoutes } from '@/pages/reference-data';
import { reportsRoutes } from '@/pages/reports';
import { analyticsRoutes } from '@/pages/analytics';

export const router = createBrowserRouter([
  { path: routes.login, element: <LoginPage />, errorElement: <ErrorPage /> },
  { path: routes.logout, element: <LogoutPage />, errorElement: <ErrorPage /> },
  {
    element: (
      <PrivateRoutes>
        <AppLayout>
          <Outlet />
        </AppLayout>
      </PrivateRoutes>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      dataMaskingRoutes,
      {
        element: <ProtectedRoutes requiredPermissions={[Permission.PortalAccess]} />,
        children: [
          analyticsRoutes,
          auditLogRoutes,
          customerRelationshipManagementRoutes,
          fundManagementRoutes,
          investorManagementRoutes,
          referenceDataRoutes,
          reportsRoutes,
          { path: '*', element: <PageLayout>Page Not Found</PageLayout> },
        ],
      },
    ],
  },
]);
